export const getIsNotPrintable = (reportType, singleReportPrint)=>reportType === 'patientsBgDataReportPrint' || singleReportPrint && singleReportPrint !== reportType;
